<template>
  <v-menu
    v-model="showDate"
    :disabled="loading"
    :close-on-content-click="false"
    :nudge-right="0"
    data-testId="menu-date-picker"
    lazy
    offset-y
    full-width
    min-width="290px" >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dayDisplay"
        :label="dateLabel"
        :rules="rulesIsDate"
        data-testId="text-field-dateLabel"
        prepend-icon="mdi-calendar"
        readonly
        v-on="on" />
    </template>
    <v-date-picker
      v-model="day"
      :locale="locale"
      :min="datePickerMin"
      :max="datePickerMax"
      data-testId="date-picker"
      @input="selectDate(day)">
      <v-spacer/>
      <v-btn
        v-show="clearDate"
        data-testId="btn-Clear-date"
        flat
        color="secondary"
        @click="doClearDate()">
        {{ $t('Clear date') }}
      </v-btn>
      <v-spacer/>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    componentKey: {
      type: Number,
      required: true,
      default: () => []
    },
    rulesIsDate: {
      type: Array,
      required: true,
      isDate: [ v => true ]
    },
    dateLabel: {
      type: String,
      required: true,
      default: () => []
    },
    initialDate: {
      type: Date,
      required: true
    },
    minDate: {
      type: Date | Boolean,
      required: true,
      default: false
    },
    maxDate: {
      type: Date | Boolean,
      required: true,
      default: false
    },
    dateFormat: {
      type: String,
      required: true,
      default: () => []
    },
    clearDate: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    locale: 'en',
    showDate: false,
    day: '',
    dayDisplay: '',
    rules: {
      isDate: [ v => true ]
    }
  }),
  computed: {
    datePickerMin () {
      if (!this.minDate) {
        return ''
      }
      return this.Maglink.GetCustomDate(this.minDate, 'yyyy-mm-dd')
    },
    datePickerMax () {
      if (!this.maxDate) {
        return ''
      }
      return this.Maglink.GetCustomDate(this.maxDate, 'yyyy-mm-dd')
    }
  },
  mounted () {
    this.locale = localStorage.currentLanguage
    this.dayDisplay = this.Maglink.GetCustomDate(this.initialDate, this.dateFormat)
    this.day = this.Maglink.GetCustomDate(this.initialDate, 'yyyy-mm-dd')
  },
  methods: {
    selectDate (dateStr) {
      let dateItems = dateStr.split('-')
      let dt = new Date(+(dateItems[0] * 1), dateItems[1] - 1, +(dateItems[2] * 1))

      this.day = dateStr
      this.dayDisplay = this.Maglink.GetCustomDate(dt, this.dateFormat)
      this.showDate = false

      this.$emit('getDate', this.componentKey, this.day)
    },
    doClearDate () {
      this.dayDisplay = undefined
      this.day = undefined
      this.showDate = false

      this.$emit('getDate', this.componentKey, this.day)
    }
  }
}
</script>
